import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { Icon, Image } from 'semantic-ui-react';

import ContactCardView from '../../ContactCardView/ContactCardView';
import hospitalMarker from '../../../assets/hospital_marker.svg';
import { getGoogleMapsApiKey } from '../../../helpers/googleMaps';

const DEFAULT_CENTER = { lat: 41.7227202, lng: 1.837 };
const DEFAULT_MARKER = { lat: 41.7227202, lng: 1.8318629 };
const DEFAULT_ZOOM = 15;

const MapMarker = ({ onClick }) => (
  <Image
    className="map-marker"
    src={hospitalMarker}
    alt=""
    onClick={onClick}
    style={{ maxWidth: '36px', width: '36px', top: '-18px' }}
  />
);

MapMarker.propTypes = {
  onClick: PropTypes.func,
};

const GoogleMapBody = ({ data }) => {
  const [mounted, setMounted] = useState(false);
  const [contactCardVisible, setContactCardVisible] = useState(true);

  useEffect(() => {
    setMounted(true);
  }, []);

  const center = {
    lat: Number(data?.center_lat) || DEFAULT_CENTER.lat,
    lng: Number(data?.center_lng) || DEFAULT_CENTER.lng,
  };
  const marker = {
    lat: Number(data?.marker_lat) || DEFAULT_MARKER.lat,
    lng: Number(data?.marker_lng) || DEFAULT_MARKER.lng,
  };
  const zoom = Number(data?.zoom) || DEFAULT_ZOOM;
  const showContactCard = data?.show_contact_card !== false;
  const apiKey = getGoogleMapsApiKey();

  if (!mounted) {
    return (
      <div
        className="csj-google-map csj-google-map--loading"
        aria-hidden="true"
      />
    );
  }

  if (!apiKey) {
    return (
      <div className="csj-google-map csj-google-map--missing-key" role="status">
        <p>
          Google Maps API key not configured (set RAZZLE_GOOGLE_MAPS_API_KEY).
        </p>
      </div>
    );
  }

  return (
    <div className="csj-google-map">
      <div className="google-map-container">
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={center}
          defaultZoom={zoom}
        >
          <MapMarker
            lat={marker.lat}
            lng={marker.lng}
            onClick={() => showContactCard && setContactCardVisible(true)}
          />
        </GoogleMapReact>
      </div>
      {showContactCard ? (
        <div
          className={
            contactCardVisible
              ? 'contact-card-container'
              : 'contact-card-container hidden'
          }
        >
          <ContactCardView />
          <Icon name="close" onClick={() => setContactCardVisible(false)} />
        </div>
      ) : null}
    </div>
  );
};

GoogleMapBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default GoogleMapBody;
